"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var baseViewModel_1 = require("./base/baseViewModel");
var placementsUtils_1 = require("../../app/utils/placementsUtils");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.firstPlacement = ko.observable();
        this.secondPlacement = ko.observable();
        this.placementViewStatsCollector = false;
        $(".chip-search-books").on("click", function () {
            if (_this.app.canBeHandledByApp()) {
                try {
                    _this.app.getAppMobileHandler().handleSearchFilters();
                    return;
                }
                catch (ex) {
                    console.error(ex);
                }
            }
            _this.app.closePopup();
            _this.app.f7.popup("#findBookPopup");
        });
        var vm = this.app.createViewModel("searchPopup", {
            urlFunc: function (genres, format, form, params) {
                var hasForm = form !== "any";
                var hasFormat = hasForm || format !== "any";
                var hasGenres = hasFormat || genres != "all";
                var genreUrlPart = hasGenres ? "/" + genres : "";
                var formatUrlPart = hasFormat ? "/" + format : "";
                var formUrlPart = hasForm ? "/" + form : "";
                return "work/genre" + genreUrlPart + formatUrlPart + formUrlPart + "?" + $.param(params);
            },
            defaultUsingNeuralNetworks: options.defaultUsingNeuralNetworks,
            defaultExceptGenres: options.defaultExceptGenres,
            defaultHideFinished: options.defaultHideFinished
        });
        this.findBookPopupViewModel = vm;
        ko.applyBindings(this.findBookPopupViewModel, $("#findBookPopup")[0]);
        vm.format(options.format);
        vm.form(options.form);
        vm.genres(options.genres);
        vm.exceptGenreIds(options.exceptGenreIds);
        vm.state(options.state);
        vm.series(options.series);
        vm.access(options.access);
        vm.download(options.download);
        vm.lastUpdate(options.lastUpdate);
        vm.published(options.published);
        vm.duration(options.duration);
        vm.length(options.length);
        vm.sorting(options.sorting);
        vm.hideFinished(options.hideFinished);
        vm.seriesOrder(options.seriesOrder);
        vm.usingNeuralNetworks(options.usingNeuralNetworks);
        $(document).ready(function () {
            setTimeout(function () {
                _this.loadPlacements(options.placementId);
            }, 100);
        });
    }
    /**
    * Загрузка спонсорского контента
    * @param placementId Идентификатор места размещения
    */
    ViewModel.prototype.loadPlacements = function (placementId) {
        var _this = this;
        this.placementId = placementId;
        this.firstPlacement(null);
        this.secondPlacement(null);
        if (!placementId)
            return;
        placementsUtils_1.default.getPlacements("?id=" + placementId, function (items) {
            _this.firstPlacement(items[0]);
            if (items.length > 1) {
                _this.secondPlacement(items[1]);
            }
            setTimeout(function () {
                placementsUtils_1.default.startViewStatsCollector();
            }, 200);
        });
    };
    /** Скрыть спонсорский контент*/
    ViewModel.prototype.hidePlacements = function () {
        this.firstPlacement(null);
        this.secondPlacement(null);
        app.f7.closeModal($("#popoverPlacementInfo")[0]);
        placementsUtils_1.default.hidePlacements(this.placementId);
    };
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=workGenre.js.map